import { Box } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { SWToolTip } from 'components/SWToolTip';
import useTimeDisplayMode from 'hooks/useTimeDisplayMode';
import { getPastDaysRangeInTz } from 'utils/helpers/dateTime';
import DtcHandler from 'handlers/dtc.handler';
import { useTranslation } from 'react-i18next';

export const DtcNotificationCounter = () => {
  const { t } = useTranslation();
  const dtcHandler = new DtcHandler();
  const accessToken = useAppSelector((state) => state.authReducer.accessToken);
  const { timezoneBasedOnDisplayMode } = useTimeDisplayMode();
  const dtcData = useAppSelector(
    (state) => state.dtcReducer?.allGroupedDTCData
  );
  const navigate = useNavigate();

  const handleRedirect = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigate('/diagnostic-trouble-codes', {
      state: {
        data: {
          isActive: true,
        },
      },
    });
  };

  // effects
  React.useEffect(() => {
    const fetchData = async () => {
      if (accessToken && timezoneBasedOnDisplayMode) {
        const { startDateTimeInTz, endDateTimeInTz } = getPastDaysRangeInTz(
          timezoneBasedOnDisplayMode,
          5
        );
        const payload = {
          startDate: startDateTimeInTz.toISOString(),

          endDate: endDateTimeInTz.toISOString(),
        };
        await dtcHandler.getAllGroupedData(payload);
      }
    };

    void fetchData();
  }, [accessToken, timezoneBasedOnDisplayMode]);

  const activeDtcCount = React.useMemo(() => {
    return Array.isArray(dtcData)
      ? dtcData?.filter((item: any) => item?.is_active).length
      : 0;
  }, [dtcData]);

  return (
    <SWToolTip title={t('dtc_notifications')}>
      <button className="notification-btn" onClick={handleRedirect}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Triangle background */}
          <path d="M12 2 L22 20 H2 Z" fill="white" />

          {/* Cutout-style exclamation mark using background color */}
          <line
            x1="12"
            y1="8"
            x2="12"
            y2="12"
            stroke="#0f1f3a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <circle cx="12" cy="15.5" r="1.2" fill="#0f1f3a" />
        </svg>

        {activeDtcCount > 0 && (
          <span className="notification-badge">{activeDtcCount}</span>
        )}
      </button>
    </SWToolTip>
  );
};
